import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicNoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mic_none"}/>
}
